/* Built In Imports */

/* External Imports */
import { Box, Image, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { useMediaQuery } from 'react-responsive';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@moms/Utility/StructuredTextParser';
import GlobalAuthoritySt from '@moms/styleData/GlobalAuthoritySt';

/* Styles */
/* Services */

const Card = ({ title, description, thumbnail, hasBorder, lang }) => (
  <Box
    flex={1}
    ps={{ base: '50px' }}
    pe={{ base: '26px' }}
    py={{ base: '15px' }}
    display="flex"
    flexDirection="column"
    gap="16px"
    borderEnd={hasBorder ? '1px solid #ffffff33' : 'none'}
  >
    <Image
      src={thumbnail?.url}
      w="184px"
      h="184px"
      alt={thumbnail?.alt}
      title={thumbnail?.title}
    />
    <Text {...GlobalAuthoritySt[lang]?.cardTitle}>{title}</Text>
    <StructuredTextParser
      {...GlobalAuthoritySt[lang]?.cardDescription}
      str={render(description)}
      mt="0"
    />
  </Box>
);

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */

const MdLayout = ({ region, lang, sectionContent }) => {
  const cardData =
    sectionContent.find(
      item => item._modelApiKey === 'card_info3_column_group'
    ) || sectionContent?.[0];

  const titleData =
    sectionContent.find(item => item._modelApiKey === 'section_title') ||
    sectionContent?.[1];

  const isSlider = useMediaQuery({ maxWidth: 1023 });

  return (
    <>
      {!isSlider && (
        <Box maxW="1330px" mx={{ sm: 'auto' }} color="#fff">
          <Box
            my="105px"
            mx={{ base: '40px', xl: '95px' }}
            display="flex"
            flexDirection="column"
            gap="64px"
          >
            <Box display="flex" flexWrap="wrap">
              <Box
                px={{
                  base: '12px',
                  lg: lang === 'ta' ? '22px' : '12px',
                  xl: '38px',
                }}
                py="128px"
                flex={1}
              >
                <Text {...GlobalAuthoritySt[lang]?.titleText}>
                  {titleData?.titleText}
                </Text>
                <Box display="flex" flexDirection="row" gap="8px" pt="5px">
                  <Text {...GlobalAuthoritySt[lang]?.titleSubtext}>
                    {titleData?.titleSubtext}
                  </Text>
                  <Text
                    {...GlobalAuthoritySt[lang]?.titleSubtext}
                    fontStyle="italic"
                    color={lang === 'ta' ? '#fff' : '#EC1C2D'}
                  >
                    {titleData?.additionalTextLine}
                  </Text>
                </Box>
              </Box>

              {cardData?.cards?.slice(0, 2).map((card, index, array) => (
                <Card
                  key={index}
                  title={card.title}
                  description={card.description}
                  thumbnail={card.thumbnail}
                  hasBorder={index !== array.length - 1}
                  lang={lang}
                />
              ))}
            </Box>

            <Box display="flex" flexWrap="wrap">
              {cardData?.cards?.slice(2).map((card, index, array) => (
                <Card
                  key={index + 2}
                  title={card.title}
                  description={card.description}
                  thumbnail={card.thumbnail}
                  hasBorder={index !== array.length - 1}
                  lang={lang}
                />
              ))}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

const PhoneSlider = ({ region, lang, sectionContent }) => {
  const cardData =
    sectionContent.find(
      item => item._modelApiKey === 'card_info3_column_group'
    ) || sectionContent?.[0];

  const titleData =
    sectionContent.find(item => item._modelApiKey === 'section_title') ||
    sectionContent?.[1];
  const isSlider = useMediaQuery({ maxWidth: 1023 });

  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,

    customPaging: i => (
      <Box
        width={{ base: '11.39px' }}
        height={{ base: '11.39px' }}
        borderRadius="50%"
        mt={{ base: '1rem', lg: '0' }}
        bgColor=" #FFFFFF33"
        transition="background-color 0.3s, opacity 0.3s"
        css={{
          '.slick-active &': {
            backgroundColor: '#EC1C2D',
            opacity: '1',
          },
        }}
        _hover={{ bgColor: '#08152D' }}
      />
    ),
  };
  return (
    <>
      {isSlider && (
        <Box
          display={isSlider ? 'block' : 'none'}
          mt={{ base: '1rem', md: '100px' }}
          mb={{ base: '120px' }}
          ms={{ base: '16px', md: '35px' }}
          color="#fff"
        >
          <Box
            pb={{ base: '48px' }}
            textAlign={{ base: 'start', md: 'center' }}
          >
            <Text {...GlobalAuthoritySt[lang]?.titleText}>
              {titleData?.titleText}
            </Text>
            <Box
              display="flex"
              flexDirection="row"
              gap="8px"
              pt="5px"
              justifyContent={{ base: 'start', md: 'center' }}
            >
              <Text {...GlobalAuthoritySt[lang]?.sliderTitleSubtext}>
                {titleData?.titleSubtext}
              </Text>
              <Text
                {...GlobalAuthoritySt[lang]?.sliderTitleSubtext}
                fontStyle="italic"
                color={lang === 'ta' ? '#fff' : '#EC1C2D'}
              >
                {titleData?.additionalTextLine}
              </Text>
            </Box>
          </Box>
          <Box>
            <Slider {...sliderSettings}>
              {cardData?.cards?.map((slide, index) => {
                return (
                  <Box
                    key={index}
                    // display="flex !important"
                    flexDir="column"
                    gap="16px"
                    pe="20px"
                    width={{ base: '290px !important' }}
                  >
                    <Image
                      src={slide?.thumbnail?.url}
                      w="266px"
                      h="266px"
                      alt={slide?.thumbnail?.alt}
                      title={slide?.thumbnail?.title}
                    />
                    <Text py="1rem" {...GlobalAuthoritySt[lang]?.cardTitle}>
                      {slide?.title}
                    </Text>
                    <StructuredTextParser
                      {...GlobalAuthoritySt[lang]?.SliderDescription}
                      str={render(slide?.description)}
                      mt="0"
                      w="270px"
                    />
                  </Box>
                );
              })}
            </Slider>
          </Box>
          <style jsx global>{`
            .slick-dots li button:before {
              color: rgba(255, 255, 255, 0.2) !important;
              font-size: 12px !important;
            }
            .slick-dots li.slick-active button:before {
              color: #ec1c2d !important;
            }
            .slick-slider .slick-dots {
              bottom: -70px !important;
              text-align: center;
            }
            .slick-dots li {
              margin: 0 4px !important;
            }
            slick-slide:focus {
              outline: none !important;
              border: none !important;
            }
            .slick-slide div:focus {
              outline: none !important;
            }
            .slick-slide img {
              outline: none !important;
            }
          `}</style>
        </Box>
      )}
    </>
  );
};

export const GlobalAuthority = ({ sectionContent, region, lang }) => {
  return (
    <Box borderBottom="1px solid #ffffff33">
      {/* md layout */}
      <MdLayout region={region} lang={lang} sectionContent={sectionContent} />

      {/* phone slider */}
      <PhoneSlider
        region={region}
        lang={lang}
        sectionContent={sectionContent}
      />
    </Box>
  );
};
